import { connect } from 'react-redux';
import {
  userFetch,
  userSetSubscriptionActive,
  userActionNames,
} from 'services/store/user/actions';
import {
  checkErrorSelector,
  checkLoadingSelector,
} from 'services/store/base/selectors';
import SuccessSubscriptionModal from './SuccessSubscriptionModal';

// @ts-ignore
const mapStateToProps = ({ base }) => ({
  isLoading: checkLoadingSelector(base, [userActionNames.USER_FETCH]),
  userFetchError: checkErrorSelector(base, [userActionNames.USER_FETCH]),
});

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  userFetch: (): void => {
    dispatch(userFetch());
  },
  setSubscriptionActive: (): void => {
    dispatch(userSetSubscriptionActive());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessSubscriptionModal);
